import CoreService from "@/src/modules/core/services/core";

import {notificationFeedApi} from "../api";
import type {NotificationItem, NotificationFeedQueryParams, NotificationTopic} from "../types";

class NotificationFeedService extends CoreService {
  async getFeed(params?: NotificationFeedQueryParams) {
    const {data} = await notificationFeedApi.getNotifications(params);
    return data;
  }

  async getUnread(params?: Omit<NotificationFeedQueryParams, "unread" | "include_discarded">) {
    return this.getFeed({
      ...params,
      unread: true,
      include_discarded: false,
    });
  }

  async markReadByIds(ids: string[]) {
    if (!ids.length) {
      return 0;
    }

    const {data} = await notificationFeedApi.markRead({notification_ids: ids});
    return data.data.updated;
  }

  async discardByIds(ids: string[]) {
    if (!ids.length) {
      return 0;
    }

    const {data} = await notificationFeedApi.discard({notification_ids: ids});
    return data.data.updated;
  }

  async markAllUnreadByTopic(topic: NotificationTopic) {
    const {data} = await notificationFeedApi.markRead({
      all_unread: true,
      topic,
    });
    return data.data.updated;
  }

  async discardAllUnreadByTopic(topic: NotificationTopic) {
    const {data} = await notificationFeedApi.discard({
      all_unread: true,
      topic,
    });
    return data.data.updated;
  }

  getUnreadNonDiscardedCount(items: NotificationItem[]) {
    return items.filter((item) => !item.read_at && !item.discarded_at).length;
  }
}

export const notificationFeedService = new NotificationFeedService();
